import { render, staticRenderFns } from "./_legend-tag.vue?vue&type=template&id=e5e2f8f6&"
import script from "./_legend-tag.vue?vue&type=script&lang=js&"
export * from "./_legend-tag.vue?vue&type=script&lang=js&"
import style0 from "./_legend-tag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports